import { render } from "./AskOption.vue?vue&type=template&id=960b5182&scoped=true"
import script from "./AskOption.vue?vue&type=script&lang=js"
export * from "./AskOption.vue?vue&type=script&lang=js"

import "./AskOption.vue?vue&type=style&index=0&id=960b5182&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-960b5182"]])

export default __exports__